/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IScheduler {
    getSchedulerSettings(cancelToken?: CancelToken): AxiosPromise<SchedulerSettings>;
    getDynamicScheduler(portalUrl: string | null | undefined, cancelToken?: CancelToken): AxiosPromise<DynamicScheduler>;
}

export const BASE_URL_TOKEN_Scheduler = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class Scheduler implements IScheduler {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
        private readonly axios: AxiosInstance,
        @inject(BASE_URL_TOKEN_Scheduler) @optional() private readonly baseUrl = ''
    ) {}

    getSchedulerSettings(cancelToken?: CancelToken): AxiosPromise<SchedulerSettings> {
        let url_ = '/v1/customerportal/scheduler/settings';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<SchedulerSettings>(options_));
    }

    getDynamicScheduler(portalUrl: string | null | undefined, cancelToken?: CancelToken): AxiosPromise<DynamicScheduler> {
        let url_ = '/v1/customerportal/scheduler/dynamic?';
        if (portalUrl !== undefined && portalUrl !== null)
            url_ += 'portalUrl=' + encodeURIComponent('' + portalUrl) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<DynamicScheduler>(options_));
    }
}

export interface SchedulerSettings {
    enabled: boolean;
    bookingFrameURL?: string | undefined;
}

export interface DynamicScheduler {
    type: DynamicSchedulerType;
    id?: string | number;
    dataApiKey?: string;
    publicCode?: string;
}

export enum DynamicSchedulerType {
    None = 0,
    SchedulingPro = 1,
    WebScheduler2 = 2,
}
